import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import type { Faq } from "@/types/content";

export default function FaqAccordion() {
  const [openId, setOpenId] = useState<string | null>((faqs as Faq[])[0]?.id ?? null);

  return (
    <div className="flex flex-col gap-3">
      {(faqs as Faq[]).map((faq) => {
        const open = openId === faq.id;
        return (
          <div
            key={faq.id}
            className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
          >
            <button
              type="button"
              onClick={() => setOpenId(open ? null : faq.id)}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
            >
              <span className="font-heading font-medium text-foreground-950 text-sm md:text-base">
                {faq.question}
              </span>
              <i
                className={`shrink-0 text-lg text-accent-500 transition-transform ${
                  open ? "ri-subtract-line" : "ri-add-line"
                }`}
              />
            </button>
            {open && (
              <div className="px-5 pb-5 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}